import { Route, Routes } from "react-router-dom";
import { IndexPage } from "./pages/Index";
import { RateCalculatorProvider } from "./context/rate-calculator-state";

export function RateCalculatorRoutes() {
    return (
        <RateCalculatorProvider>
            <Routes>
                <Route index element={<IndexPage />} />
            </Routes>
        </RateCalculatorProvider>
    );
}
